/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Problem_3_DescInputs */

const en_mk_problem_3_desc = /** @type {(inputs: Mk_Problem_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Most AI agent products require installing a CLI, a daemon, and your own model credentials — a non-starter for most teams in Indonesia.`)
};

const id_mk_problem_3_desc = /** @type {(inputs: Mk_Problem_3_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Produk agen AI kebanyakan mengharuskan pasang CLI, daemon, dan kredensial model sendiri — mustahil untuk sebagian besar tim di Indonesia.`)
};

/**
* | output |
* | --- |
* | "Most AI agent products require installing a CLI, a daemon, and your own model credentials — a non-starter for most teams in Indonesia." |
*
* @param {Mk_Problem_3_DescInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_problem_3_desc = /** @type {((inputs?: Mk_Problem_3_DescInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Problem_3_DescInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_problem_3_desc(inputs)
	return en_mk_problem_3_desc(inputs)
});